<template>
  <Trigger
    ref="coros-popper"
    v-model:popup-visible="visible"
    :disabled="true"
    position="bl"
    @hide="keyword = ''"
  >
    <div
      :class="['coros-strength-exercise-select inline-block border border-dark-60', { active: visible, disabled: disabled }]"
      @click.stop="open"
    >
      <Input
        v-model="keyword"
        class="bg-transparent border-0 outline-none h-full w-full placeholder:text-white"
        :placeholder="showingName || $t('R4004')"
      />
      <i
        v-if="!disabled"
        class="iconfont iconxiala1 select-icon"
      ></i>
    </div>

    <template #content>
      <div
        :class="['coros-strength-exercise-select-box bg-bg-5', { searching: keyword }]"
        @mouseleave="changeActiveExercise('')"
      >
        <div class="left-box border-r border-dark-60 flex">
          <!--        主分类-->
          <ul class="categorise text-center color-white text-14 font-medium flex flex-row justify-start items-center border-box bg-fill-5">
            <li
              v-for="category in categorise"
              :key="category.key"
              :tilte="category.text"
              :class="['item', { active: activeCategory === category.key }]"
              @click="changeActiveCategory(category.key)"
            >
              {{ $t(category.text) }}
            </li>
          </ul>
          <!--        子分类-->
          <ul
            v-if="subCategories.length > 0"
            class="sub-categories"
          >
            <li
              v-for="subCategory in subCategories"
              :key="activeCategory + '-' + subCategory.dataValue"
              :tilte="subCategory.text"
              :class="['sub-category', { active: activeSubCategory === subCategory.dataValue }]"
              @click="changeActiveSubCategory(subCategory.dataValue)"
            >
              {{ subCategory.text }}
            </li>
          </ul>
          <!--        动作列表-->
          <ul class="exercises text-14">
            <li
              v-for="exercise in needingExercises"
              :key="exercise.id"
              :tilte="exercise.nameText"
              class="line-ellispis-1 flex flex-row justify-between align-center"
              :class="['exercise', { active: activeExercise === exercise.id }]"
            >
              <div
                class="name truncate flex-1"
                @mouseover="changeActiveExercise(exercise.id)"
                @click="changeExercise(exercise.id)"
              >
                {{ exercise.nameText }}
              </div>
              <div
                v-show="activeCategory === 'custom'"
                class="custom-operate ml-10"
              >
                <span
                  class="operate edit"
                  @click.stop="openCustomEdit(exercise)"
                  >{{ $t('C5003') }}</span
                >
                <span>|</span>
                <Spin :loading="removingExercise[exercise.id]">
                  <span
                    class="operate delete"
                    @click.stop="deleteCustomExercise(exercise.id, $event)"
                    >{{ $t('C5004') }}</span
                  >
                </Spin>
              </div>
            </li>
          </ul>
        </div>
        <div class="right-box">
          <!--      动作详情-->
          <div
            v-if="activeExerciseInfo"
            class="exercise-detail"
          >
            <!--          图片仅在非自定义的时候显示-->
            <div
              v-if="activeExerciseInfo.access === ACCESS_OFFICIAL"
              class="flex flex-row justify-center items-center w-full exercise-image-wrapper"
            >
              <div class="exercise-image block-image rounded-sm">
                <img :src="activeExerciseInfo.videoUrl || activeExerciseInfo.sourceUrl" />
              </div>
            </div>

            <div class="exercise-introduce">
              <div class="name">{{ activeExerciseInfo.nameText }}</div>
              <!--              官方的动作-->
              <template v-if="activeExerciseInfo.access === ACCESS_OFFICIAL">
                <dl class="introduce-item">
                  <dt>{{ $t('G2009') }}</dt>
                  <dd>{{ $t(activeExerciseInfo.desc) }}</dd>
                </dl>
              </template>
              <!--              自定义动作-->
              <template v-else-if="activeExerciseInfo.overview">
                <dl class="introduce-item">
                  <dt>{{ $t('G2009') }}</dt>
                  <dd>{{ $t(activeExerciseInfo.overview) }}</dd>
                </dl>
              </template>
              <dl
                v-if="activeExerciseInfo.partText"
                class="introduce-item"
              >
                <dt>{{ $t('R4018') }}</dt>
                <dd>{{ activeExerciseInfo.partText }}</dd>
              </dl>
              <dl
                v-if="activeExerciseInfo.muscleText"
                class="introduce-item"
              >
                <dt>{{ $t('R4020') }}</dt>
                <dd>{{ activeExerciseInfo.muscleText }}</dd>
              </dl>
              <dl
                v-if="activeExerciseInfo.equipmentText"
                class="introduce-item"
              >
                <dt>{{ $t('R4023') }}</dt>
                <dd>{{ activeExerciseInfo.equipmentText }}</dd>
              </dl>
            </div>
          </div>
          <!--        历史记录-->
          <div
            v-else
            class="history flex flex-col justify-start"
          >
            <div class="history-title flex flex-row justify-start items-center px-16 text-14 font-medium text-white">
              <i class="iconfont icontianjia1 title-icon mr-8 text-12"></i>
              <span>{{ $t('R1015') }}</span>
            </div>
            <ul class="history-list text-12 font-normal flex-1 overflow-y-scroll">
              <li
                v-for="exercise in historyExerciseList"
                :key="exercise.id"
                :tilte="exercise.nameText"
                class="py-8 cursor-pointer pointer-cursor truncate px-12"
                @click="changeExercise(exercise.id)"
              >
                {{ exercise.nameText }}
              </li>
            </ul>
            <div
              class="adding-custom history-footer text-center leading-40 text-14 font-medium cursor-pointer flex flex-row justify-center items-center"
              @click="openCustomEdit()"
            >
              <span class="mr-4 iconfont icontianjia"></span>
              <span class="inline-block align-middle">{{ $t('R4016') }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Trigger>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { Trigger, Message, Spin, Input } from '@arco-design/web-vue';
import { cloneDeep } from 'lodash';
import { initStore as useAppStore } from '@client/store/initStore';
import { openModal4customStrengthExercise } from '@client/components/CustomStrengthExerciseEditor';
import { strengthExercise } from '@client/api';
import '@client/components/CustomStrengthExerciseEditor/style.scss';
import { trainingProgramStore as useTrainingProgramStore } from '@client/store/trainingProgramStore';
import { memberDataStore as memberDataStoreRef } from '@client/store/memberDataStore';
import { userStore as useUserStore } from '@client/store/userStore';
const { t } = useI18n();
const appStore = useAppStore();
const userStore = useUserStore();
const memberDataStore = memberDataStoreRef();
const trainingProgramStore = useTrainingProgramStore();
const vm = getCurrentInstance();
Message._context = vm.appContext;

// 官方的
const ACCESS_OFFICIAL = 0;
// 自定义的
const ACCESS_CUSTOM = 1;

const visible = ref(false);
const keyword = ref('');
const activeCategory = ref('part');
const activeSubCategory = ref('');
const activeExercise = ref('');
const removingExercise = ref({});

const historyList = ref([]);

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  modelValue: {
    type: [Number, String],
    default() {
      return '';
    }
  },
  teamId: {
    type: [Number, String],
    default() {
      return '';
    }
  },
  userId: {
    type: [Number, String],
    default() {
      return '';
    }
  },
  defaultExerciseName: {
    type: [String],
    default() {
      return '';
    }
  }
});
const emit = defineEmits(['update:modelValue', 'change']);

watch(visible, () => {
  activeExercise.value = props.modelValue;
});

const exerciseCategoryObj = computed(() => {
  const { activitySourceDataProfile } = appStore;
  const result = activitySourceDataProfile.find((item) => item.subDataType === 20);
  if (!result) return {};
  return result.detailObj.reduce((acc, item) => {
    if (!acc[item.dataType]) {
      acc[item.dataType] = {};
    }
    acc[item.dataType][item.dataValue] = item;
    return acc;
  }, Object.create(null));
});

const subCategories = computed(() => {
  if (!exerciseCategoryObj.value[activeCategory.value]) {
    return [];
  }
  return Object.values(exerciseCategoryObj.value[activeCategory.value])
    .sort((a, b) => {
      return a.sortNo - b.sortNo;
    })
    .map((item) => {
      return {
        ...item,
        text: t(item.dataCode)
      };
    });
});
const activeSubCategoryInfo = computed(() => {
  if (!exerciseCategoryObj.value[activeCategory.value] || !exerciseCategoryObj.value[activeCategory.value][activeSubCategory.value]) {
    return {};
  }
  return exerciseCategoryObj.value[activeCategory.value][activeSubCategory.value];
});

const exerciseList = computed(() => {
  const firstArr = [];
  const secondArr = [];
  trainingProgramStore.exercises.forEach((item) => {
    if (item.defaultOrder !== 0 || item.exerciseType === 4) {
      firstArr.push(item);
    } else {
      secondArr.push(item);
    }
  });
  firstArr.sort((a, b) => {
    return a.exerciseType - b.exerciseType;
  });
  const result = [].concat(firstArr, secondArr);
  result.forEach((item) => {
    item.nameText = t(item.name);
    // item.desc = `${item.name}_DESC`;

    item.desc = t(`${item.name}_desc`);
  });
  return result;
});
const categorise = [
  {
    // 部位
    text: 'T5026',
    key: 'part'
  },
  {
    // 器械
    text: 'T5034',
    key: 'equipment'
  },
  {
    // 肌肉
    text: 'T5048',
    key: 'muscle'
  },
  {
    // 自定义
    text: 'T5064',
    key: 'custom'
  }
];
const needingExercises = computed(() => {
  let result = [];

  if (activeCategory.value === 'custom') {
    result = exerciseList.value.filter((item) => {
      if (!item.nameText.includes(keyword.value)) {
        return false;
      }
      return item.access === ACCESS_CUSTOM || !Object.prototype.hasOwnProperty.call(item, 'access');
    });
  } else {
    result = exerciseList.value.filter((item) => {
      if (!item.nameText.includes(keyword.value)) {
        return false;
      }
      return item.access === ACCESS_OFFICIAL;
    });

    if (activeCategory.value !== '') {
      result = result.filter((item) => {
        return Object.prototype.hasOwnProperty.call(item, activeCategory.value);
      });
    }

    if (activeSubCategory.value !== '') {
      result = result.filter((item) => {
        return item[activeCategory.value].includes(Number(activeSubCategoryInfo.value.dataValue));
      });
    }
  }

  const baseArr = [];
  let otherArr = [];

  result.forEach((item) => {
    if (item.defaultOrder !== 0 || item.exerciseType === 4) {
      baseArr.push(item);
      return;
    }
    otherArr.push(item);
  });

  otherArr = otherArr.sort((a, b) => {
    return a.nameText.localeCompare(b.nameText);
  });

  return [].concat(baseArr, otherArr);
});
const activeExerciseInfo = computed(() => {
  // if (that.activeCategory === 'custom') {
  //   return null
  // }
  const info = getExercise(activeExercise.value);
  // 热身、训练、放松、休息   不需要显示右边的介绍栏
  if (!info || info.defaultOrder !== 0 || info.exerciseType === 4 || !Object.prototype.hasOwnProperty.call(info, 'access')) {
    return null;
  }
  return info;
});
const showingName = computed(() => {
  if (!props.modelValue) {
    return '';
  }
  const exercise = getExercise(props.modelValue, true);
  if (!exercise) {
    return props.defaultExerciseName || '';
  }
  return exercise.nameText || '';
});
const historyExerciseList = computed(() => {
  const result = [];
  const list = [];
  exerciseList.value.forEach((item) => {
    if (historyList.value.includes(item.id)) {
      list.push(item);
    }
  });

  historyList.value.forEach((item) => {
    for (let n = 0, length = list.length; n < length; n++) {
      if (list[n].id === item) {
        result.push(list[n]);
        break;
      }
    }
  });

  return result;
});
const getExercise = (id, fromAll = false) => {
  const exerciseData = fromAll ? exerciseList.value : needingExercises.value;
  const keys = ['part', 'muscle', 'equipment'];

  function getI18nText(dataType, dataValue) {
    return exerciseCategoryObj.value &&
      exerciseCategoryObj.value[dataType] &&
      exerciseCategoryObj.value[dataType][dataValue] &&
      exerciseCategoryObj.value[dataType][dataValue].dataCode
      ? t(exerciseCategoryObj.value[dataType][dataValue].dataCode)
      : '';
  }

  let result = null;
  for (let n = 0, length = exerciseData.length; n < length; n++) {
    const item = exerciseData[n];
    if (item.id === id) {
      result = item;

      keys.forEach((key) => {
        if (result[key]) {
          result[`${key}Text`] = result[key]
            .map((item) => {
              return getI18nText(key, item);
            })
            .filter((item) => item !== '')
            .join(',');
        }
      });
      break;
    }
  }

  return result;
};

const getHistory = () => {
  historyList.value = JSON.parse(window.localStorage.getItem('strengthHistory') || '[]');
};
const addHistory = (id) => {
  const newHistoryData = cloneDeep(historyList.value);
  const index = newHistoryData.indexOf(id);
  if (index >= 0) {
    newHistoryData.splice(index, 1);
  }
  newHistoryData.unshift(id);

  if (newHistoryData.length > 20) {
    newHistoryData.splice(20, 5);
  }

  historyList.value = newHistoryData;
  saveHistory();
};
const saveHistory = () => {
  window.localStorage.setItem('strengthHistory', JSON.stringify(historyList.value));
};
const open = () => {
  reset();
  visible.value = true;
};
const reset = () => {
  getHistory();
  keyword.value = '';
  activeCategory.value = 'part';
  activeSubCategory.value = '';
  activeExercise.value = props.modelValue;
};
// 变更当前的分类
const changeActiveCategory = (key) => {
  if (activeCategory.value === key) {
    activeCategory.value = '';
  } else {
    activeCategory.value = key;
  }
  activeSubCategory.value = '';
  activeExercise.value = '';
};
// 变更当前的子分类
const changeActiveSubCategory = (key) => {
  if (activeSubCategory.value === key) {
    activeSubCategory.value = '';
  } else {
    activeSubCategory.value = key;
  }
  activeExercise.value = '';
};
// 变更当前的动作
const changeActiveExercise = (key) => {
  activeExercise.value = key;
};
// 变更当前的动作
const changeExercise = (key) => {
  const exercise = getExercise(key, true);
  addHistory(key);
  activeExercise.value = key;
  visible.value = false;
  emit('update:modelValue', exercise.id);
  emit('change', cloneDeep(exercise));
};

// 打开自定义编辑
const openCustomEdit = (data) => {
  visible.value = false;
  openModal4customStrengthExercise(data, t('R1113'));
};

const deleteCustomExercise = (id, e) => {
  removingExercise.value[id] = true;
  return strengthExercise
    .api4deleteStrengthExercise({
      data: [id],
      params: {
        teamId: props.teamId,
        userId: props.userId
      }
    })
    .then((data) => {
      if (props.modelValue === id) {
        for (let n = 0, length = exerciseList.value.length; n < length; n++) {
          const item = exerciseList.value[n];
          if (item.exerciseType === 2) {
            emit('change', cloneDeep(item));
            break;
          }
        }
      }
      const { teamId, userId: teamUserId } = getUserParams();
      const userId = teamUserId || userStore.userId;
      return trainingProgramStore.getExercises(teamId, userId);
    })
    .catch((err) => {
      console.error(err);
      Message.error(err.message);
    })
    .finally(() => {
      removingExercise.value[id] = false;
    });
};

onMounted(() => {
  activeExercise.value = props.modelValue;
});
const getUserParams = () => {
  const { teamViewMode, userData } = memberDataStore;

  if (teamViewMode && userData) {
    const { userId, teamId } = userData;
    return {
      userId,
      teamId
    };
  } else {
    return {};
  }
};
</script>

<style lang="scss">
.coros-strength-exercise-select {
  position: relative;
  height: 32px;
  border-radius: 2px;
  box-sizing: border-box;
  transition: all 0.2s ease-in;
  cursor: pointer;

  flex-direction: row;
  align-items: center;

  // &:hover {
  //   border: 1px solid #00b3ff;
  // }

  &.disabled {
    border: 1px solid rgba(255, 255, 255, 0.1);
    cursor: not-allowed;
  }

  &.active {
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  .text {
    flex-grow: 1;
    flex-shrink: 1;

    margin-right: 5px;
    font-size: inherit;
    color: #ffffff;
    overflow: hidden;

    word-break: keep-all;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .select-icon {
    flex-grow: 0;
    flex-shrink: 0;

    font-size: 12px;
    color: #9f9f9f;
  }
}

.coros-strength-exercise-select-box {
  width: 752px;
  height: 348px;
  // background: #313b59;
  border-radius: 2px;

  display: flex;
  flex-direction: row;
  align-items: stretch;

  .left-box {
    border-right: 1px solid rgba(255, 255, 255, 0.05);
    flex-direction: column;
    width: 460px;
    flex: 0 0 460px;
    .categorise {
      .item {
        position: relative;
        width: 25%;
        height: 32px;
        line-height: 32px;
        // background: #5a637a;
        cursor: pointer;
        // border: 1px solid rgba(255, 255, 255, 0.05);
        &:after {
          content: ' ';
          position: absolute;
          top: 0;
          left: 100%;
          width: 1px;
          height: 100%;
          z-index: 1;
          background-color: rgba(255, 255, 255, 0.05);
        }

        &:nth-last-of-type(1) {
          border-right: 0;

          &:after {
            content: '';
            width: 0;
            height: 0;
            background-color: transparent;
          }
        }

        &:hover {
          @apply text-primary-6;
        }

        &.active {
          @apply bg-primary-6;
          color: #ffffff;
        }
      }
    }

    .sub-categories {
      flex-grow: 0;
      flex-shrink: 0;

      padding: 12px 8px 4px 16px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      @apply border-b;
      @apply border-dark-60;
      box-sizing: border-box;
      // box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);

      .sub-category {
        display: inline-block;
        margin: 0 8px 8px 0;
        width: calc(25% - 8px);
        height: 28px;
        line-height: 26px;
        border-radius: 2px;
        color: rgba(255, 255, 255, 0.6);
        border: 1px solid rgba(255, 255, 255, 0.1);
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        cursor: pointer;
        box-sizing: border-box;

        overflow: hidden;
        word-break: keep-all;
        white-space: nowrap;
        text-overflow: ellipsis;

        &:hover {
          @apply text-primary-6;
          @apply border;
          @apply border-primary-6;
        }

        &.active {
          color: #ffffff;
          border: 1px solid #ffffff;
        }
      }
    }

    .exercises {
      flex-grow: 1;
      flex-shrink: 1;
      overflow: auto;
      max-width: 100%;
      padding: 8px 0;

      .exercise {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 30px;
        padding: 0 16px 0 24px;
        overflow: hidden;
        color: rgba(255, 255, 255, 0.8);
        cursor: pointer;
        &:hover {
          background-color: #3d4766;
          @apply text-primary-6;
        }
        .gap-span {
          flex-grow: 1;
          flex-shrink: 1;
        }

        .custom-operate {
          flex-grow: 0;
          flex-shrink: 0;

          color: #ffffff;
          display: flex;
          flex-direction: row;
          align-items: center;

          span {
            margin-right: 4px;
          }

          .operate {
            cursor: pointer;

            &:hover {
              @apply text-primary-6;
            }
          }
        }
      }
    }
  }

  .right-box {
    // flex-grow: 0;
    // flex-shrink: 0;
    width: 292px;
    position: relative;
    flex: 0 0 292px;
    .history {
      height: 100%;
      .history-title {
        height: 32px;
        flex: 0 0 32px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
      }

      .history-list {
        color: rgba(255, 255, 255, 0.6);
        li {
          overflow: hidden;
          word-break: keep-all;
          white-space: nowrap;
          text-overflow: ellipsis;
          &:hover {
            background-color: #3d4766;
            @apply text-primary-6;
          }
        }
      }

      .history-footer {
        border-top: 1px solid rgba(255, 255, 255, 0.05);
        flex: 0 0 40px;
        height: 40px;
        @apply text-primary-6;
        transition: all 0.2s linear;
        &:hover {
          color: #ffffff;
          @apply bg-primary-6;
        }
      }
    }

    .exercise-detail {
      position: relative;
      width: 100%;
      height: 100%;

      display: flex;
      flex-direction: column;
      .exercise-image-wrapper {
        @apply py-16;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
      }
      .exercise-image {
        width: 140px;
        height: 140px;
      }

      .exercise-introduce {
        flex-grow: 1;
        flex-shrink: 1;
        overflow: auto;

        padding: 12px 16px;

        .name {
          margin-bottom: 16px;
          font-size: 14px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.8);
        }

        .introduce-item {
          margin-bottom: 12px;

          &:nth-last-of-type(1) {
            margin-bottom: 0;
          }

          dt {
            margin-bottom: 2px;
            font-size: 12px;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.8);
            line-height: 18px;
          }

          dd {
            font-size: 12px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.6);
            line-height: 18px;
            white-space: pre-wrap;
          }
        }
      }
    }
  }

  &.searching {
    .left-box {
      .categorise {
        display: none;
      }
      .sub-categories {
        display: none;
      }
    }
  }
}
</style>
